import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { duckify, singleDuck } from "utils/duckify";
import { customers, flashMessages, rateCards as rateCardsDuck } from '../../ducks/index';
import { ensureKeyed } from "utils";
import registeredComponent from "utils/registeredComponent";
import Placeholder from '../Placeholder';
import FlashRoot from "components/FlashMessage/FlashRoot";
import currencies from '../../../../config/currencies.json'
import { getCurrencySymbol } from '../../utils/i18n';

const RateCard = ({ rate_card_canonical_name, rateCards, allDucksReady, dispatch, customer, readOnly }) => {
  if (!allDucksReady) {
    return <Placeholder.loading />;
  }

  const selectRateCard = (canonicalName) => rateCards.find((card) => card.canonical_name === canonicalName);
  const [rateCard, setRateCard] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const currency = currencies.find((curr) => curr.code === customer.currency);

  useEffect(() => {
    setRateCard(selectRateCard(rate_card_canonical_name));
  }, []);

  const updateRateCard = () => {
    dispatch(customers.actions.update(customer, { customer: { rate_card_canonical_name: rateCard.canonical_name } }))
      .then(() => {
        setSubmitting(false);
        dispatch(
          flashMessages.actions.show({ message: 'Rate card updated!', type: 'success', dismissible: true })
        );
      })
      .catch(() => {
        setSubmitting(false);
        dispatch(
          flashMessages.actions.show({
            message: 'Rate card could not be updated due to an error.',
            type: 'danger',
            dismissible: true
          })
        );
      });
  };

  return (
    <div id='rate-card-form'>
      <fieldset>
        <FlashRoot />

        {readOnly ? '' : <legend>Rate Card</legend>}
        <div className='base-setup-fields'>
          {readOnly ? '' :
            <div className='base-setup-field-group'>
              <label className='base-setup-field-label'>Rate Card</label>
              <div className='base-setup-field-value'>
                <select
                  name='rate-card-selector'
                  onChange={(e) => setRateCard(selectRateCard(e.target.value))}
                  value={rateCard.canonical_name}
                  className='base-setup-field-select'
                >
                  {
                    rateCards
                      .filter(card => !card.deprecated || card.canonical_name === rateCard.canonical_name)
                      .map(card => (
                        <option value={card.canonical_name}>{card.name}</option>
                      )).map(ensureKeyed())
                  }
                </select>
              </div>
            </div>
          }

          <div className='base-setup-field-group'>
            <label className='base-setup-field-label'>Domestic Credit Card (%)</label>
            <div className='base-setup-field-value'>
              <input id="domestic_cc_percent" type='text' disabled value={rateCard.domestic_cc_percent} className='base-setup-field-input' />
            </div>
          </div>

          <div className='base-setup-field-group'>
            <label className='base-setup-field-label'>International Credit Card (%)</label>
            <div className='base-setup-field-value'>
              <input id="intl_cc_percent" type='text' disabled value={rateCard.intl_cc_percent} className='base-setup-field-input' />
            </div>
          </div>

          <div className='base-setup-field-group'>
            <label className='base-setup-field-label'>ACH ({getCurrencySymbol()} per transaction)</label>
            <div className='base-setup-field-value'>
              <input id="ach_rate" type='text' disabled value={rateCard.ach_rate} className='base-setup-field-input' />
            </div>
          </div>

          <div className='base-setup-field-group'>
            <label className='base-setup-field-label'>NSF / E-Check Return (flat amount in US Dollars)</label>
            <div className='base-setup-field-value'>
              <input id="nsf_rate" type='text' disabled value={rateCard.nsf_rate} className='base-setup-field-input' />
            </div>
          </div>

          <div className='base-setup-field-group'>
            <label className='base-setup-field-label'>Chargeback / Dispute (flat amount in US Dollars) </label>
            <div className='base-setup-field-value'>
              <input id="chargeback_rate" type='text' disabled value={rateCard.chargeback_rate} className='base-setup-field-input' />
            </div>
          </div>

          {readOnly ? '' : <button className='btn btn-primary' type='submit' disabled={submitting} onClick={updateRateCard}>Save</button>}
        </div>
      </fieldset>
    </div>
  );
};

const mapDucksToProps = () => {
  const currentCustomer = singleDuck(customers, 'current');
  return {
    rateCards: rateCardsDuck,
    customer: currentCustomer
  };
};

RateCard.propTypes = {
  rateCards: PropTypes.arrayOf({
    ach_rate: PropTypes.string,
    chargeback_rate: PropTypes.string,
    domestic_cc_percent: PropTypes.string,
    intl_cc_percent: PropTypes.string,
    name: PropTypes.string,
    nsf_rate: PropTypes.string,
    canonical_name: PropTypes.string,
  }),
  readOnly: PropTypes.bool,
};

RateCard.defaultProps = {
  rateCards: [],
  readOnly: false,
};

export default registeredComponent('RateCard')(duckify(mapDucksToProps)(RateCard));
